module.exports = __webpack_public_path__ + "static/media/maintenance.b650a065.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/img/error/maintenance.png
// module id = 703
// module chunks = 8